import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {},
}));

export default useStyles;
